var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-sm"},[_c('p',[_vm._v("Copyright © 2007 - "+_vm._s(_vm.currentYear)+" expondo")])])}
var staticRenderFns = []

export { render, staticRenderFns }